import React from "react";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import TermsConditionsContent from "./TermsConditionsContent";
import GenericDrawer from "../../../../generic/TOCgeneric/GenericDrawer";
import SingleHeadingText from "../TocHeader/SingleHeadingText";
import TocStockHeader from "../TocHeader/TocStockHeader";
const TermsAndConditions = (props) => {
    const device = DeviceContext();
    return (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
        React.createElement(TocStockHeader, { children: React.createElement(SingleHeadingText, { title: "Terms & Conditions", closeFunction: () => props.setShow(false), withClose: true }) }),
        React.createElement(TermsConditionsContent, null))) : (React.createElement(GenericDrawer, { show: props.show, setShow: props.setShow, headerComp: React.createElement(React.Fragment, null,
            React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Terms & Conditions")), bodyComp: React.createElement(TermsConditionsContent, null) }))));
};
export default TermsAndConditions;
